var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185,
    height: 60,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#240C39",
    d: "M8 0h169c4.4 0 8 3.6 8 8v44c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8V8c0-4.4 3.6-8 8-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M95.7 31.4c-2.5 0-4.6 2.1-4.6 4.6 0 2.5 2.1 4.6 4.6 4.6 2.5 0 4.6-2 4.6-4.6 0-1.2-.5-2.4-1.3-3.3-.9-.9-2.1-1.3-3.3-1.3Zm0 7.3c-1.1.1-2.2-.5-2.7-1.6-.5-1-.3-2.3.5-3.1.8-.8 2-1.1 3.1-.7 1.1.4 1.8 1.4 1.8 2.6 0 .7-.2 1.4-.7 1.9-.6.6-1.3.9-2 .9Zm-10.1-7.3c-2.5 0-4.6 2.1-4.6 4.6 0 2.5 2.1 4.6 4.6 4.6 2.5 0 4.6-2 4.6-4.6 0-1.2-.5-2.4-1.3-3.3-.9-.9-2.1-1.3-3.3-1.3Zm0 7.3c-1.1.1-2.2-.5-2.7-1.6-.5-1-.3-2.3.5-3.1.8-.8 2-1.1 3.1-.7 1.1.4 1.8 1.4 1.8 2.6 0 .7-.2 1.4-.7 1.9-.6.6-1.3.9-2 .9Zm-12-5.9v1.9h4.7c-.1.9-.5 1.8-1.1 2.4-.9 1-2.3 1.5-3.6 1.4-2.9 0-5.2-2.3-5.2-5.2 0-2.9 2.3-5.2 5.2-5.2 1.3 0 2.6.5 3.5 1.4l1.4-1.4c-1.3-1.3-3.1-2-4.9-2-2.6-.1-5.1 1.2-6.4 3.5-1.3 2.2-1.3 5 0 7.3 1.3 2.2 3.8 3.6 6.4 3.5 1.9.1 3.7-.6 5-2 1.1-1.2 1.7-2.9 1.7-4.5 0-.4 0-.8-.1-1.2l-6.6.1Zm49 1.5c-.6-1.7-2.1-2.9-3.9-2.9-1.2 0-2.3.5-3.2 1.4-.8.9-1.2 2-1.2 3.2 0 1.2.4 2.4 1.3 3.2.9.9 2 1.3 3.3 1.3 1.5 0 3-.7 3.8-2l-1.6-1.1c-.5.8-1.3 1.3-2.3 1.3-1 0-1.8-.5-2.2-1.4l6.2-2.5-.2-.5Zm-6.2 1.5c0-.7.2-1.3.6-1.8.5-.5 1.1-.8 1.8-.8s1.4.3 1.7 1l-4.1 1.6Zm-5 4.4h2V26.8h-2v13.4Zm-3.3-7.8c-.7-.7-1.6-1.1-2.5-1.1-2.5.1-4.4 2.1-4.4 4.6 0 2.5 1.9 4.5 4.4 4.6.9 0 1.8-.4 2.4-1.1h.1v.7c0 1.8-.9 2.7-2.5 2.7-1 0-1.9-.7-2.3-1.6l-1.8.7c.7 1.6 2.3 2.7 4.1 2.7 2.4 0 4.3-1.4 4.3-4.8v-8.1H108l.1.7Zm-2.4 6.3c-1.4-.1-2.6-1.3-2.6-2.8 0-1.4 1.1-2.7 2.6-2.8.7 0 1.4.3 1.8.9.5.5.7 1.2.6 1.9.1.7-.2 1.4-.6 1.9-.4.6-1.1.9-1.8.9Zm26.4-11.9h-4.8v13.4h2v-5.1h2.8c1.6.1 3.1-.7 3.9-2 .8-1.3.8-3 0-4.4-.8-1.2-2.3-2-3.9-1.9Zm0 6.5h-2.8v-4.6h2.9c1.3 0 2.3 1 2.3 2.3 0 1.3-1.1 2.3-2.4 2.3Zm12.5-2c-1.5-.1-2.9.7-3.6 2.1l1.8.7c.4-.7 1.1-1.1 1.8-1 .5-.1 1 .1 1.4.4.4.3.7.8.7 1.3v.2c-.7-.3-1.4-.5-2.1-.5-1.9 0-3.9 1.1-3.9 3 0 .8.4 1.6 1 2.2.6.6 1.5.8 2.3.8 1 .1 2-.4 2.6-1.3h.1v1.1h1.9v-5.2c.1-2.4-1.7-3.7-4-3.8Zm-.3 7.4c-.7 0-1.6-.3-1.6-1.1 0-1.1 1.1-1.4 2.2-1.4.6 0 1.3.1 1.8.5-.1 1.1-1.1 2-2.4 2Zm11.5-7.1-2.3 5.8h-.1l-2.4-5.8h-2.2l3.6 8.1-2.1 4.5h2.1l5.5-12.7h-2.1v.1Zm-18.2 8.6h2V26.8h-2v13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M73.3 19c0 .8-.3 1.6-.8 2.1-.6.6-1.5 1-2.4 1-1.4 0-2.6-.8-3.1-2.1s-.2-2.7.7-3.7c.6-.6 1.5-1 2.4-1 .5 0 .9.1 1.3.3.4.2.7.4 1 .7l-.6.6c-.4-.5-1.1-.8-1.8-.8s-1.3.3-1.8.8-.7 1.1-.7 1.8c0 1 .6 2 1.5 2.4.9.4 2 .2 2.8-.5.3-.4.5-.8.5-1.3H70v-.8h3.1c.2.2.2.3.2.5Zm4.9-2.7h-2.9v2H78v.8h-2.7v2h2.9v.9h-3.8v-6.4h3.8v.7Zm3.6 5.7H81v-5.7h-1.8v-.8h4.5v.8h-1.9V22Zm5 0v-6.4h.8V22h-.8Zm4.6 0h-.8v-5.7h-1.8v-.8h4.5v.8h-1.8V22h-.1Zm10.2-.9c-1.3 1.3-3.4 1.3-4.8 0-1.3-1.3-1.3-3.4 0-4.8 1.3-1.3 3.4-1.3 4.8 0 1.3 1.4 1.3 3.5 0 4.8Zm-4.1-.5c1 1 2.6 1 3.5 0 1-1 1-2.7 0-3.7s-2.5-1-3.5 0-1 2.7 0 3.7Zm6.2 1.4v-6.4h1l3.2 5v-5h.8V22h-.9l-3.3-5.3V22h-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M33.3 16.1c-.4.4-.5 1-.5 1.5v23.8c0 .5.1 1.1.5 1.5l.1.1 13.4-13.3v-.3L33.3 16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m51.2 34.1-4.4-4.4v-.3l4.4-4.5.1.1 5.3 3c1.5.9 1.5 2.2 0 3.1l-5.3 3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m51.3 34-4.6-4.5-13.4 13.4c.6.6 1.6.6 2.2.1l15.8-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m51.3 25-15.8-9c-.7-.5-1.6-.5-2.2.1l13.5 13.4 4.5-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m51.2 33.9-15.7 8.9c-.6.5-1.5.5-2.2 0l-.1.1.1.1c.6.5 1.5.5 2.2 0l15.8-9-.1-.1Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.3 42.7c-.4-.4-.5-1-.5-1.5v.2c0 .5.1 1.1.5 1.5v-.2Zm23.3-11.8-5.4 3 .1.1 5.3-3c.6-.3 1-.9 1.1-1.5-.1.6-.5 1.1-1.1 1.4Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35.5 16.2 21.1 11.9c.6.3 1 .8 1.1 1.4-.1-.7-.5-1.3-1.1-1.5L35.5 16c-1.5-.9-2.7-.1-2.7 1.6v.2c0-1.7 1.2-2.5 2.7-1.6Z",
    opacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 41.401,
    x2: 29.925,
    y1: 17.428,
    y2: 28.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 58.586,
    x2: 32.426,
    y1: 29.5,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 47.644,
    x2: 28.078,
    y1: 32.584,
    y2: 52.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 28.688,
    x2: 37.42,
    y1: 15.342,
    y2: 24.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h185v60H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.17e91967734b126d26a2e44c29cabc8f.svg";
export { ForwardRef as ReactComponent };